<template>
  <span
    class="text-center text-[12px] font-medium rounded-full px-[10px] py-[2px] inline-block"
    :style="{ backgroundColor: statusText.color.sub, color: statusText.color.main }"
  >
    {{ statusText.label }}
  </span>
</template>

<script>
import { statusMapping } from '../../config'

export default {
  name: 'StatusPackingPill',
  props: {
    status: {
      type: String,
      default: 'Unknown',
    },
  },
  computed: {
    statusText() {
      if (statusMapping[this.status]) {
        return statusMapping[this.status]
      }

      const normalizedStatus = this.normalizeStatus(this.status)
      if (statusMapping[normalizedStatus]) {
        return statusMapping[normalizedStatus]
      }

      return statusMapping.Unknown
    },
  },
  methods: {
    normalizeStatus(status) {
      if (!status) return 'Unknown'
      const lower = String(status).toLowerCase()
      if (lower === 'canceled' || lower === 'cancelled' || lower === 'dibatalkan') return 'Dibatalkan'
      if (lower === 'packing' || lower === 'dipacking') return 'Dipacking'
      if (lower === 'submitted' || lower === 'belum dipacking' || lower === 'diajukan') return 'Belum Dipacking'
      if (lower === 'waiting pickup' || lower === 'menunggu pickup') return 'Menunggu Pickup'
      if (lower === 'dikirim' || lower === 'terkirim' || lower === 'delivered') return 'Dikirim'
      return status
    },
  },
}
</script>
